import { createTheme } from '@mui/material/styles';

// Team Jak color palette
const teamJakColors = {
  primary: '#00b7ed',
  primaryDark: '#0095c4',
  primaryLight: '#4fc9f1',
  white: '#ffffff',
  textPrimary: '#333333',
  textSecondary: '#666666',
  background: '#f5f5f5',
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
};

const theme = createTheme({
  palette: {
    primary: {
      main: teamJakColors.primary,
      dark: teamJakColors.primaryDark,
      light: teamJakColors.primaryLight,
      contrastText: teamJakColors.white,
    },
    secondary: {
      main: teamJakColors.textSecondary,
      contrastText: teamJakColors.white,
    },
    background: {
      default: teamJakColors.white,
      paper: teamJakColors.white,
    },
    text: {
      primary: teamJakColors.textPrimary,
      secondary: teamJakColors.textSecondary,
    },
    success: {
      main: teamJakColors.success,
    },
    warning: {
      main: teamJakColors.warning,
    },
    error: {
      main: teamJakColors.error,
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: teamJakColors.primaryDark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: teamJakColors.primary,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: teamJakColors.white,
          borderRight: '1px solid #e0e0e0',
        },
      },
    },
  },
});

export default theme;
export { teamJakColors };
